import { MODAL_TYPE, modalStore } from '../../store/modalStore';
import { useIsMobile } from '../../hook/useIsMobile';
import { IS_TAB_OPEN_DATE } from '../../hook/useDateHook';
import { getNotStartText } from '../../constants/commonModal';
import dayjs from 'dayjs';
import { CommonModalPc } from './CommonModal/CommonModal.pc';
import { CommonModalMobile } from './CommonModal/CommonModal.mobile';

export type CommonModalViewProps = {
  isVisibleCommon: boolean;
  modalType: MODAL_TYPE | null;
  notStartText: ReturnType<typeof getNotStartText>;
  onConfirm: () => void;
};

export const CommonModal = () => {
  const isMobile = useIsMobile();
  const { isVisibleCommon, modalType, hideModal, commonCallback1 } = modalStore();

  const props: CommonModalViewProps = {
    isVisibleCommon,
    modalType,
    notStartText: getNotStartText(dayjs(IS_TAB_OPEN_DATE).format('M월 D일(월)')),
    onConfirm: () => {
      commonCallback1?.();
      hideModal();
    },
  };

  return isMobile ? <CommonModalMobile {...props} /> : <CommonModalPc {...props} />;
};
